/* Evashu International Content System v1.2 — behavior only. */
(function () {
  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function ensureEditorialToc(root) {
    if (root.getAttribute('data-evc-variant') !== 'editorial') return;
    if (!root.querySelector('[data-evc-editorial-toc-enabled]')) return;
    if (root.querySelector('[data-evc-editorial-toc-runtime]')) return;

    var read = root.querySelector('.evc__read');
    if (!read) return;

    var prose = read.querySelector('.evc__prose');
    if (!prose) return;

    var headings = prose.querySelectorAll('h2, h3');
    if (!headings.length) return;

    var desktop = document.createElement('div');
    desktop.className = 'evc__toc-card';
    desktop.setAttribute('data-evc-editorial-toc-runtime', '');
    desktop.style.marginBottom = '24px';
    desktop.innerHTML = '<span class="evc__toc-title">On this page</span><div class="evc__toc-links" data-evc-toc-target></div>';

    var mobile = document.createElement('details');
    mobile.className = 'evc__toc-mobile';
    mobile.setAttribute('data-evc-editorial-toc-runtime-mobile', '');
    mobile.innerHTML = '<summary>View sections</summary><div class="evc__toc-mobile-links" data-evc-toc-target></div>';

    prose.parentNode.insertBefore(desktop, prose);
    prose.parentNode.insertBefore(mobile, prose);
  }

  function buildToc(root) {
    var proseBlocks = Array.prototype.slice.call(root.querySelectorAll('.evc__prose'));
    var headings = [];
    proseBlocks.forEach(function (prose) {
      headings = headings.concat(Array.prototype.slice.call(prose.querySelectorAll('h2, h3')));
    });
    if (!headings.length) {
      root.querySelectorAll('.evc__toc-card, .evc__toc-mobile').forEach(function (el) { el.hidden = true; });
      return;
    }

    var used = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) id = base + '-' + n++;
        h.id = id;
      }
      used[h.id] = true;
    });

    root.querySelectorAll('[data-evc-toc-target]').forEach(function (target) {
      target.innerHTML = '';
      headings.forEach(function (h) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.setAttribute('data-level', h.tagName === 'H3' ? '3' : '2');
        target.appendChild(a);
      });
    });
  }

  function enhanceTables(root) {
    root.querySelectorAll('.evc__prose table').forEach(function (table) {
      var headerCells = Array.prototype.slice.call(table.querySelectorAll('thead th'));
      if (!headerCells.length) {
        var firstRow = table.querySelector('tr');
        if (firstRow) headerCells = Array.prototype.slice.call(firstRow.querySelectorAll('th'));
      }
      var labels = headerCells.map(function (cell) { return cell.textContent.trim(); });
      table.querySelectorAll('tbody tr').forEach(function (row) {
        Array.prototype.slice.call(row.children).forEach(function (cell, index) {
          if (cell.tagName === 'TD') cell.setAttribute('data-label', labels[index] || '');
        });
      });
      table.classList.add('evc__table--responsive');
      if (!table.parentElement || !table.parentElement.classList.contains('evc__table-wrap')) {
        var wrapper = document.createElement('div');
        wrapper.className = 'evc__table-wrap';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  }

  function installHeroArtStyles() {
    if (document.getElementById('evc-hero-art-styles')) return;
    var style = document.createElement('style');
    style.id = 'evc-hero-art-styles';
    style.textContent = [
      '.evc__hero-art{position:relative;isolation:isolate;display:grid;place-items:center;min-width:0;overflow:hidden;aspect-ratio:4/3;border:1px solid var(--evc-border);border-radius:var(--evc-radius-media);background:var(--evc-teal);box-shadow:var(--evc-shadow-xs);color:#fff}',
      '.evc__hero-art--wide{width:min(1100px,100%);margin:28px auto 44px;aspect-ratio:16/9}',
      '.evc__hero-art:before{content:"";position:absolute;inset:-24%;z-index:-2;background:radial-gradient(circle at 28% 32%,rgba(235,217,181,.22) 0 1px,transparent 2px),radial-gradient(circle at 72% 62%,rgba(235,217,181,.16) 0 1px,transparent 2px);background-size:34px 34px,46px 46px;transform:rotate(-7deg)}',
      '.evc__hero-art:after{content:"";position:absolute;width:62%;aspect-ratio:1;border:1px solid rgba(235,217,181,.30);border-radius:50%;z-index:-1;box-shadow:0 0 0 36px rgba(235,217,181,.055),0 0 0 78px rgba(235,217,181,.035)}',
      '.evc__hero-art-content{position:relative;z-index:2;width:min(82%,720px);padding:28px;text-align:center}',
      '.evc__hero-art-label{display:block;margin-bottom:12px;color:var(--evc-gold-pale);font:750 10px/1.25 var(--evc-sans);letter-spacing:.16em;text-transform:uppercase}',
      '.evc__hero-art-mark{display:block;color:#fff;font:500 clamp(52px,8vw,104px)/.92 var(--evc-serif);letter-spacing:-.04em;text-wrap:balance}',
      '.evc__hero-art-mark--word{font-size:clamp(34px,5.4vw,70px);letter-spacing:-.03em}',
      '.evc__hero-art-caption{display:block;margin-top:16px;color:#F7F1E7;font:550 12px/1.5 var(--evc-sans);letter-spacing:.035em}',
      '.evc__hero-art-nodes{position:absolute;inset:0;z-index:1;pointer-events:none}',
      '.evc__hero-art-node{position:absolute;width:9px;height:9px;border:1px solid rgba(235,217,181,.72);border-radius:50%;background:rgba(20,56,64,.45)}',
      '.evc__hero-art-node:nth-child(1){left:13%;top:22%}.evc__hero-art-node:nth-child(2){right:15%;top:26%}.evc__hero-art-node:nth-child(3){left:20%;bottom:18%}.evc__hero-art-node:nth-child(4){right:21%;bottom:16%}',
      '.evc__hero-art[data-evc-hero-art="reference"],.evc__hero-art[data-evc-hero-art="mineral"],.evc__hero-art[data-evc-hero-art="authenticity"],.evc__hero-art[data-evc-hero-art="compare"]{background:var(--evc-surface-alt);color:var(--evc-heading)}',
      '.evc__hero-art[data-evc-hero-art="reference"] .evc__hero-art-label,.evc__hero-art[data-evc-hero-art="mineral"] .evc__hero-art-label,.evc__hero-art[data-evc-hero-art="authenticity"] .evc__hero-art-label,.evc__hero-art[data-evc-hero-art="compare"] .evc__hero-art-label{color:var(--evc-gold-ink)}',
      '.evc__hero-art[data-evc-hero-art="reference"] .evc__hero-art-mark,.evc__hero-art[data-evc-hero-art="mineral"] .evc__hero-art-mark,.evc__hero-art[data-evc-hero-art="authenticity"] .evc__hero-art-mark,.evc__hero-art[data-evc-hero-art="compare"] .evc__hero-art-mark{color:var(--evc-heading)}',
      '.evc__hero-art[data-evc-hero-art="reference"] .evc__hero-art-caption,.evc__hero-art[data-evc-hero-art="mineral"] .evc__hero-art-caption,.evc__hero-art[data-evc-hero-art="authenticity"] .evc__hero-art-caption,.evc__hero-art[data-evc-hero-art="compare"] .evc__hero-art-caption{color:var(--evc-body)}',
      '.evc__hero-art[data-evc-hero-art="reference"]:after,.evc__hero-art[data-evc-hero-art="mineral"]:after,.evc__hero-art[data-evc-hero-art="authenticity"]:after,.evc__hero-art[data-evc-hero-art="compare"]:after{border-color:rgba(184,134,45,.30);box-shadow:0 0 0 36px rgba(184,134,45,.055),0 0 0 78px rgba(184,134,45,.035)}',
      '.evc__hero-art[data-evc-hero-art="reference"] .evc__hero-art-node,.evc__hero-art[data-evc-hero-art="mineral"] .evc__hero-art-node,.evc__hero-art[data-evc-hero-art="authenticity"] .evc__hero-art-node,.evc__hero-art[data-evc-hero-art="compare"] .evc__hero-art-node{border-color:rgba(184,134,45,.55);background:rgba(250,246,238,.8)}',
      '.evc__hero-art[data-evc-hero-art="birthstone"]:after{border-radius:18%;transform:rotate(45deg);box-shadow:0 0 0 36px rgba(235,217,181,.045),0 0 0 78px rgba(235,217,181,.028)}',
      '.evc__hero-art[data-evc-hero-art="authenticity"]:before,.evc__hero-art[data-evc-hero-art="compare"]:before{inset:0;background:linear-gradient(90deg,transparent 49.8%,rgba(184,134,45,.24) 50%,transparent 50.2%);transform:none}',
      '.evc__hero-art[data-evc-hero-art="ritual"]:after,.evc__hero-art[data-evc-hero-art="divination"]:after{width:48%;border-radius:50%;transform:translateX(12%);box-shadow:-34px 0 0 -1px rgba(254,252,249,.08),0 0 0 48px rgba(235,217,181,.035)}',
      '.evc__hero-media--runtime img{width:100%;height:100%;object-fit:cover}',
      '@media(max-width:980px){.evc__hero-art{width:min(760px,100%)}}',
      '@media(max-width:749px){.evc__hero-art,.evc__hero-art--wide{border-radius:16px}.evc__hero-art--wide{margin:22px auto 32px;aspect-ratio:4/3}.evc__hero-art-content{width:88%;padding:20px}.evc__hero-art-mark{font-size:clamp(46px,16vw,72px)}.evc__hero-art-mark--word{font-size:clamp(31px,10vw,48px)}.evc__hero-art-caption{font-size:11.5px}}',
      '@media(prefers-reduced-motion:reduce){.evc__hero-art *{animation:none!important;transition:none!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function titleText(root) {
    var h1 = root.querySelector('h1');
    return h1 ? h1.textContent.trim() : '';
  }

  function pathText() {
    return String(window.location.pathname || '').toLowerCase();
  }

  function firstTitleWord(title) {
    return String(title || '').trim().split(/\s+/)[0] || 'Crystal';
  }

  function angelNumber(title) {
    var match = String(title || '').match(/angel\s+number\s+([0-9]+)/i);
    return match ? match[1] : '111';
  }

  function zodiacName(title) {
    var match = String(title || '').match(/crystals?\s+for\s+([a-z]+)/i);
    return match ? match[1] : 'Zodiac';
  }

  function monthName(title) {
    var match = String(title || '').match(/^(January|February|March|April|May|June|July|August|September|October|November|December)\b/i);
    return match ? match[1] : '12 Months';
  }

  function infoMark(title) {
    var text = String(title || '').toLowerCase();
    if (text.indexOf('cleanse') !== -1 || text.indexOf('care') !== -1 || text.indexOf('charge') !== -1) return 'CARE';
    if (text.indexOf('size') !== -1) return 'SIZE';
    if (text.indexOf('color') !== -1) return 'COLOR';
    if (text.indexOf('shape') !== -1 || text.indexOf('formation') !== -1) return 'FORM';
    if (text.indexOf('combination') !== -1) return 'PAIR';
    if (text.indexOf('grid') !== -1) return 'GRID';
    if (text.indexOf('chakra') !== -1) return '7';
    if (text.indexOf('navagraha') !== -1) return '9';
    return 'GUIDE';
  }

  function heroProfile(root) {
    var variant = root.getAttribute('data-evc-variant') || '';
    var title = titleText(root);
    var lower = title.toLowerCase();
    var path = pathText();

    if (variant === 'encyclopedia') {
      return { kind: 'mineral', label: 'Crystal encyclopedia', mark: firstTitleWord(title), caption: 'Properties · uses · care', word: true };
    }

    if (variant === 'information') {
      return { kind: 'reference', label: 'Evashu reference', mark: infoMark(title), caption: 'Practical crystal knowledge', word: true };
    }

    if (variant === 'editorial') {
      if (path.indexOf('crystal-altar-setup-guide') !== -1 || path.indexOf('crystals-for-home-feng-shui') !== -1) {
        return {
          kind: 'image',
          src: 'https://cdn.shopify.com/s/files/1/0752/1982/8934/files/evashu-home-altar-crystal-tree.webp?v=1787744768',
          alt: 'Evashu crystal altar arrangement for a home crystal practice'
        };
      }
      if (/^angel\s+number\b/i.test(title) || path.indexOf('angel-number-') !== -1) {
        return { kind: 'numbers', label: 'Angel number', mark: angelNumber(title), caption: 'Meaning · symbolism · reflection' };
      }
      if (lower.indexOf('numerology') !== -1 || lower.indexOf('life path') !== -1 || lower.indexOf('personal year') !== -1) {
        return { kind: 'numerology', label: 'Numerology', mark: '1 · 2 · 3', caption: 'Numbers, patterns & crystal traditions', word: true };
      }
      if (lower.indexOf('tarot') !== -1 || lower.indexOf('pendulum') !== -1 || lower.indexOf('major arcana') !== -1) {
        return { kind: 'divination', label: 'Practice guide', mark: 'TAROT', caption: 'Symbolism · ritual · crystal practice', word: true };
      }
      if (lower.indexOf('moon') !== -1 || lower.indexOf('ritual') !== -1 || lower.indexOf('meditate') !== -1 || lower.indexOf('intentions') !== -1) {
        return { kind: 'ritual', label: 'Crystal ritual', mark: lower.indexOf('moon') !== -1 ? 'MOON' : 'RITUAL', caption: 'Practice · intention · reflection', word: true };
      }
      if (lower.indexOf('rudraksha') !== -1 || lower.indexOf('navagraha') !== -1 || lower.indexOf('hindu') !== -1 || lower.indexOf('ancient indian') !== -1) {
        return { kind: 'vedic', label: 'Vedic reference', mark: lower.indexOf('navagraha') !== -1 ? '9' : 'VEDIC', caption: 'Traditional context · cultural reference', word: lower.indexOf('navagraha') === -1 };
      }
      if (lower.indexOf('cleanse') !== -1 || lower.indexOf('charge') !== -1 || lower.indexOf('elixir') !== -1) {
        return { kind: 'care', label: 'Crystal care', mark: 'CARE', caption: 'Handling · cleansing · practical safety', word: true };
      }
      return { kind: 'editorial', label: 'Evashu journal', mark: 'CRYSTAL', caption: 'Perspective · practice · culture', word: true };
    }

    if (variant === 'guide') {
      if (/crystals?\s+for\s+(aries|taurus|gemini|cancer|leo|virgo|libra|scorpio|sagittarius|capricorn|aquarius|pisces)/i.test(title)) {
        return { kind: 'zodiac', label: 'Zodiac guide', mark: zodiacName(title).toUpperCase(), caption: 'Crystal traditions for your sign', word: true };
      }
      if (lower.indexOf('birthstone') !== -1) {
        return { kind: 'birthstone', label: 'Birthstone guide', mark: monthName(title).toUpperCase(), caption: 'Stone traditions by month', word: true };
      }
      if (lower.indexOf('real vs fake') !== -1 || lower.indexOf('natural vs lab-grown') !== -1) {
        return { kind: 'authenticity', label: 'Authenticity guide', mark: 'REAL / FAKE', caption: 'What to inspect before you buy', word: true };
      }
      if (lower.indexOf(' vs ') !== -1) {
        return { kind: 'compare', label: 'Comparison guide', mark: 'A / B', caption: 'Side-by-side crystal guidance', word: true };
      }
      if (lower.indexOf('best crystals for') !== -1 || lower.indexOf('crystals for ') !== -1) {
        return { kind: 'intention', label: 'Crystal guide', mark: 'GUIDE', caption: 'Selection · context · practical use', word: true };
      }
      if (lower.indexOf('gift') !== -1 || lower.indexOf('starter') !== -1 || lower.indexOf('under $') !== -1) {
        return { kind: 'shopping', label: 'Buying guide', mark: 'CURATED', caption: 'Selection · gifting · starting points', word: true };
      }
      return { kind: 'guide', label: 'Practical guide', mark: 'GUIDE', caption: 'Clear, structured crystal guidance', word: true };
    }

    return null;
  }

  function createArt(profile, wide) {
    var art = document.createElement('div');
    art.className = 'evc__hero-art' + (wide ? ' evc__hero-art--wide' : '');
    art.setAttribute('data-evc-runtime-hero', '');
    art.setAttribute('data-evc-hero-art', profile.kind);
    art.setAttribute('aria-hidden', 'true');

    var nodes = document.createElement('div');
    nodes.className = 'evc__hero-art-nodes';
    for (var i = 0; i < 4; i++) {
      var node = document.createElement('span');
      node.className = 'evc__hero-art-node';
      nodes.appendChild(node);
    }

    var content = document.createElement('div');
    content.className = 'evc__hero-art-content';

    var label = document.createElement('span');
    label.className = 'evc__hero-art-label';
    label.textContent = profile.label;

    var mark = document.createElement('span');
    mark.className = 'evc__hero-art-mark' + (profile.word ? ' evc__hero-art-mark--word' : '');
    mark.textContent = profile.mark;

    var caption = document.createElement('span');
    caption.className = 'evc__hero-art-caption';
    caption.textContent = profile.caption;

    content.appendChild(label);
    content.appendChild(mark);
    content.appendChild(caption);
    art.appendChild(nodes);
    art.appendChild(content);
    return art;
  }

  function createRuntimeImage(profile, wide) {
    var media = document.createElement('div');
    media.className = 'evc__hero-media evc__hero-media--runtime' + (wide ? ' evc__hero-media--wide' : '');
    media.setAttribute('data-evc-runtime-hero', '');

    var img = document.createElement('img');
    img.src = profile.src;
    img.alt = profile.alt || '';
    img.loading = 'eager';
    img.fetchPriority = 'high';
    img.width = wide ? 1600 : 1200;
    img.height = 900;
    media.appendChild(img);
    return media;
  }

  function enhanceHeroVisual(root) {
    if (root.querySelector('.evc__hero-media, [data-evc-runtime-hero]')) return;
    var variant = root.getAttribute('data-evc-variant') || '';
    if (['encyclopedia', 'information', 'editorial', 'guide'].indexOf(variant) === -1) return;

    var hero = root.querySelector('.evc__hero');
    if (!hero) return;

    var profile = heroProfile(root);
    if (!profile) return;

    var wide = variant === 'editorial' || variant === 'information';
    var visual = profile.kind === 'image' ? createRuntimeImage(profile, wide) : createArt(profile, wide);
    if (wide) hero.parentNode.insertBefore(visual, hero.nextSibling);
    else hero.appendChild(visual);
  }

  function init() {
    installHeroArtStyles();
    document.querySelectorAll('.evc').forEach(function (root) {
      enhanceHeroVisual(root);
      ensureEditorialToc(root);
      buildToc(root);
      enhanceTables(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
